import React, { useMemo } from "react";
import styles from "./index.module.scss";
import { Col, Empty, Icon, Row } from "antd";
import { ListCardIcon } from "../../../../../ListCard";
import { EvaluationList2Item, ExamType, getExamTypeName } from "service/exam";
import className from "classnames";
import qs from "qs";

interface ListItemProps {
    data: EvaluationList2Item;
}

export default function ListItem({ data }: ListItemProps) {
    const fileName = useMemo(() => {
        const parsed = qs.parse(data.file);
        return (Object.values(parsed)?.[0] || data.file) as string;
    }, [data]);

    return (
        <div className={styles.root}>
            <div className={styles.main}>
                <h1 className={styles.title}>{data.examName}</h1>

                <Row
                    className={className(styles.info, styles.courseInfo)}
                    title={`${data.courseName} ${data.courseNo} ${data.courseSeq}`}>
                    <Col span={10}>课程名：{data.courseName}</Col>
                    <Col span={8}>编号：{data.courseNo}</Col>
                    <Col span={6}>序号：{data.courseSeq}</Col>
                </Row>

                <div className={styles.info}>
                    考试有效期限：{data.examStartTime} - {data.examEndTime}
                </div>

                <ListCardIcon
                    className={styles.icon}
                    variant={
                        data.examType === ExamType.Exam ? "green" : "blue"
                    }>
                    {getExamTypeName(data.examType)}
                </ListCardIcon>
            </div>

            <div className={styles.docs}>
                {!data.file && (
                    <Empty
                        className={styles.empty}
                        image={<Icon type="solution" />}
                        description="评卷专家尚未添加评审报告单"
                    />
                )}

                {data.file && (
                    <div className={styles.file}>
                        <a
                            href={data.fileViewUrl}
                            target="_blank"
                            className={styles.link}
                            rel="noreferrer">
                            <Icon type="paper-clip" />
                            &nbsp; {fileName}
                        </a>

                        <a
                            href={data.fileViewUrl}
                            target="_blank"
                            className={styles.view}
                            rel="noreferrer">
                            <Icon type="eye" />
                        </a>

                        <a
                            href={data.file}
                            target="_blank"
                            className={styles.download}
                            rel="noreferrer">
                            <Icon type="download" />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}
